export const GET_MATERIALS_LIST = 'GET_MATERIALS_LIST';
export const GET_MATERIAL = 'GET_MATERIAL';

export function getMaterialsList(data) {
  return {
    type: GET_MATERIALS_LIST,
    payload: data,
  }
}

export function getMaterial(data) {
  return {
    type: GET_MATERIAL,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/materials/index.js